import StencilHTMLElement from "./stencil-element";

class WishList extends StencilHTMLElement {
  name = "WishList";

  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('click', this.clickHiddenWishlistButton.bind(this));
  }

  clickHiddenWishlistButton() {
    const appButton = document.getElementById("swym-atw-pdp-button");
    if (appButton) {
      appButton.click();
    }
  }
}

export default WishList;